import React from "react";

import { useNavigate } from "react-router";
import { routes } from "routes";

import SecondaryButton from "components/common/SecondaryButton";
import { useTranslations } from "components/useTranslations";

const IngredientsAdditionButton: React.FC = () => {
  const navigateTo = useNavigate();
  const t = useTranslations();
  return (
    <SecondaryButton
      name="createIngredient"
      onClick={() => navigateTo(routes.ingredientsCreate)}
    >
      {t`__INGREDIENTS_INITIAL_VIEW_CREATE_BUTTON`}
    </SecondaryButton>
  );
};

export default IngredientsAdditionButton;
